<template>
  <section class="customers-read">
    <navigation-tabs
      :items="tabs"
      class="customers-read-tabs"
    />

    <state-messages
      key="customer-states"
      :state="customerState"
    >
      <template v-slot:loading>
        Carregando cliente
      </template>

      <template v-slot:error>
        Algo deu errado enquanto tentávamos carregar este cliente.
        Por favor, tente novamente.
      </template>

      <template v-slot:empty>
        Cliente não encontrado :(
      </template>
    </state-messages>

    <router-view
      v-if="customer.id"
      class="customers-read-content"
    />
  </section>
</template>

<script>
  import { mapState } from 'vuex';

  import namelize from '@sdk/helpers/formatters/namelize';

  import StateMessages from '@/components/State/Messages.vue';

  import NavigationTabs from '@/components/Navigation/Tabs.vue';

  import CustomersReadEdit from '@/views/Customers/Read/Edit.vue';

  export default {
    name: 'CustomersRead',
    components: {
      NavigationTabs,
      StateMessages,
    },
    data() {
      return {
        nav: {
          action: CustomersReadEdit,
        },
      };
    },
    computed: {
      ...mapState([
        'customers',
      ]),

      tabs() {
        const { id } = this.$route.params;

        return [{
          label: 'Informações',
          path: {
            name: 'customers-read-informations',
            params: {
              id,
            },
          },
        }, {
          label: 'Perfil',
          path: {
            name: 'customers-read-profile',
            params: {
              id,
            },
          },
        }, {
          label: 'Log de Atividades',
          path: {
            name: 'customers-read-log',
            params: {
              id,
            },
          },
          props: {
            parent: 'logCustomer',
          },
        }];
      },

      customer() {
        return this.customers.read.item;
      },
      customerState() {
        const {
          error,
          item,
          loading,
        } = this.customers.read;

        if (loading) {
          return 'loading';
        }

        if (error) {
          return 'error';
        }

        return item.id ? 'ready' : 'empty';
      },
    },
    watch: {
      $route: {
        handler(to, from) {
          if (from.params.id !== to.params.id) {
            this.resetCustomer();
          }
        },
      },
    },
    mounted() {
      this.resetCustomer();
    },
    methods: {
      resetCustomer() {
        return this.$store
          .dispatch('customers/clear', { action: 'read' })
          .then(this.getCustomer);
      },
      getCustomer() {
        this.$store
          .dispatch('customers/read', { id: this.$route.params.id })
          .then(this.gotCustomer);
      },
      gotCustomer() {
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/stylesheets/_variables.scss';

  .customers-read {
  }

  .customers-read-content {
    &.activity-log {
      margin-left: var(--product--pwa--horizontal);
      margin-right: var(--product--pwa--horizontal);

      @media all and (max-width: $cordel-breakpoint-mobile) {
        margin-left: var(--product--pwa--horizontal);
        margin-right: var(--product--pwa--horizontal);
      }
    }
  }

  .customers-read-tabs {
    margin: 0 var(--product--pwa--horizontal);

    @media all and (max-width: $cordel-breakpoint-mobile) {
      margin: 0 var(--product--pwa--horizontal);
    }
  }
</style>
